import getOr from 'lodash/fp/getOr'
import * as yup from 'yup'
import { FINANCIAL_TYPES_VALUES, PROJECTIONS_VALUES } from '../../constants'
import { MIN_DATE } from '../../../../../utils/validations/constants'
import '../../../../../utils/validations/extendYup'

const financialSchema = {
  capital_invested: yup
    .number()
    .required(),
  has_financing: yup
    .boolean()
    .required(),
  financing_used: yup
    .string(),
    // .required(),
  annual_average_income: yup
    .number()
    .required(),
  important_expenses: yup
    .string()
    .required(),
  prospects_projection: yup
    .number()
    .required()
    .oneOf(Object.values(PROJECTIONS_VALUES)),
  real_state_linked: yup
    .string()
    .required(),
  text: yup
    .string()
}

const bankingPoolSchema = yup.object().shape({
  financing_type: yup
    .number()
    .required()
    .oneOf(Object.values(FINANCIAL_TYPES_VALUES)),
  amount: yup
    .number()
    .required(),
  interest_rate: yup
    .number()
    .required(),
  entity: yup
    .string()
    .required(),
  expiration: yup
    .date()
    .min(new Date(), MIN_DATE)
    .format('dd/MM/yyyy')
    .required(),
  share: yup
    .number()
    .when(['financing_type'], {
      is: (type) => [1, 2, 3, 6].includes(type),
      then: yup.number().nullable(false).required('Por favor, indica la cuota'),
      otherwise: yup.number().nullable(true)
    })
})

const validationSchema = yup.object().shape({
  ...financialSchema,
  banking_pool: yup.array().of(bankingPoolSchema)
})

const mapPropsToValues = ({ application }) => ({
  capital_invested: getOr('', 'financial.capital_invested')(application),
  has_financing: getOr('', 'financial.has_financing')(application),
  financing_used: getOr('', 'financial.financing_used')(application),
  annual_average_income: getOr('', 'financial.annual_average_income')(application),
  important_expenses: getOr('', 'financial.important_expenses')(application),
  prospects_projection: getOr('', 'financial.prospects_projection')(application),
  real_state_linked: getOr('', 'financial.real_state_linked')(application),
  text: getOr('', 'financial.text')(application),
  banking_pool: getOr([], 'financial.banking_pool')(application)
})

export default {
  mapPropsToValues,
  validationSchema
}
